const components = {};

// 读取文件夹下所有.vue文件(不包含子目录)
const files = require.context('./', false, /\.vue$/);

files.keys().forEach(filePath => {
	// 获取文件名称，作为组件名称
	let fileName = filePath.split('/').pop().replace(/\.\w+$/, '');
	// 读取文件内容
	let fileContent = files(filePath);
	// 若该组件是通过export default导出的，优先使用.default，否则退回到使用模块的根
	components[fileName] = fileContent.default || fileContent;
});

// console.log(components)

export default components